export default function apiUrl() {
  // if (process.env.VUE_APP_API_URL.includes('localhost')) {
  //   return `http://${window.location.hostname}:3030/`
  // }
  return process.env.VUE_APP_API_URL
}
